import { Box, Button, Icon, Modal, Text, Textarea } from "@oneloop/jopijs";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import translations from "../../FichaInfo.trans.json";
import Trans from "@/components/shared/Trans";
import {
  modalTitle,
  qualifyClarification,
  modalContainer,
  textArea,
  modalBody,
} from "../feedback.module.scss";
import { sendFeedback } from "@/store/slices/components/fichaInfo/services";
import { showToast } from "@/store/slices/components/fichaInfo/FichaInfoSlice";

export default function FeedbackModal({ setOpen, showModal }) {
  const dispatch = useDispatch();
  const [comment, setComment] = useState("");
  const { hash, TOKKO_HOST } = useSelector((state) => state.FichaInfoSlice);
  const { show, like } = showModal;

  const handleFeedbackSubmit = () => {
    dispatch(
      sendFeedback({
        hash,
        data: {
          comment,
          feedback: like ? "like" : "dislike",
        },
        TOKKO_HOST,
      })
    ).then(() => {
      dispatch(showToast({ text: Trans(translations, "FeedbackQualifySend") }));
    });
    setOpen({ show: false });
  };

  return (
    show && (
      <Modal className={modalContainer} height="385px" modalBG variant="center">
        <Box __css={{ display: "flex", flexDirection: "column", gap: "32px" }}>
          <Box className={modalTitle}>
            <Icon
              icon={`${like ? "icon-destaque" : "icon-quitardestaque"}`}
              fontSize="52px"
            />
            <Modal.Header
              variant={["center", "sm"]}
              fontSize="20px"
              text={Trans(
                translations,
                like ? "FeedbackLikeModalTitle" : "FeedbackDontLikeModalTitle"
              )}
            />
          </Box>
          <Modal.Body className={modalBody} variant={["center", "sm"]}>
            <Textarea
              placeholder={Trans(translations, "FeedbackQualifyPlaceholder")}
              className={textArea}
              borderRadius="10px"
              width="100%"
              height="115px"
              onChange={(e) => setComment(e.target.value)}
            />
            <Text marginTop="9px" className={qualifyClarification}>
              {Trans(translations, "FeedbackQualifyClarification")}
            </Text>
          </Modal.Body>
          <Modal.Footer justifyContent="end" variant="center">
            <Button
              variant="primaryText"
              onClick={() => setOpen({ show: false })}
            >
              {Trans(translations, "Cancel")}
            </Button>
            <Button
              variant={["primary", "large"]}
              height="48px"
              padding="13px 26px"
              onClick={handleFeedbackSubmit}
            >
              {Trans(translations, "FeedbackQualify")}
            </Button>
          </Modal.Footer>
        </Box>
      </Modal>
    )
  );
}
